export default __webpack_public_path__ + "static/media/signIn.8d592d54.svg";